<template>
  <div>
    <v-dialog persistent v-model="recommendedPositionsDialog" width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $t("Wave.PickingFields.stock_position_select")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="recommendedPositionsDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Wave.PickingFields.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="2" class="font-weight-bold text-right">
                {{ $t("Wave.PickingFields.material") + $t("Global.colon") }}
              </v-col>
              <v-col cols="5" class="text-left">
<!--                {{-->
<!--                  $t(-->
<!--                    settings-->
<!--                      ? settings.material_name_display_type == 3-->
<!--                        ? "Material.materialNameWithCodeAndStandard"-->
<!--                        : settings.material_name_display_type == 2-->
<!--                        ? "Material.materialNameWithCode"-->
<!--                        : "Material.materialName"-->
<!--                      : "Material.materialName",-->
<!--                    [-->
<!--                      material ? material.material_code : "",-->
<!--                      material ? material.material_name : "",-->
<!--                      material ? material.standard_name : "",-->
<!--                    ]-->
<!--                  )-->
<!--                }}-->
                <span>
                  {{
                    $t(settings
                        ? settings.material_name_display_type == 1
                            ? "Material.materialName"
                            : settings.material_name_display_type == 4
                            ? "Material.nameWithCode"
                            : "Material.materialNameWithCode"
                        : "Material.materialName", [ material ? material.material_code : "", material ? material.material_name : ""])
                  }}
                </span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="material && material.standard_name && material.standard_name.length > 12" :title="material.standard_name" style="cursor: pointer">
                    {{ material.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ material ? material.standard_name : "" }}
                  </span>
                </span>
              </v-col>
              <v-col cols="2" class="font-weight-bold text-left">
                {{
                  $t("Wave.PickingFields.picked_count_num") + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="3" class="text-left">
                {{ material ? material.rate_pick_num : "" }}
              </v-col>
            </v-row>
            <v-data-table
              id="get_positions_table"
              :headers="detailsHeaders"
              :items="stockPosition"
              :expanded="stockPosition"
              item-key="position_name"
              disable-sort
              class="elevation-2 px-4 mt-4"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.pick_num="{ item }">
                <div class="d-inline-block">
                  <NumberInput
                    v-if="item.rate != 1"
                    v-model="item.stock_num"
                    dense
                  >
                    <template v-slot:append>
                      {{ item.stock_unit }}
                    </template>
                  </NumberInput>
                </div>
                <div class="d-inline-block">
                  <NumberInput v-model="item.default_num" dense>
                    <template v-slot:append>
                      {{ item.unit }}
                    </template>
                  </NumberInput>
                </div>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row
                    align="center"
                    class="ps-2"
                    v-for="stock_material_position in item.stock_material_position"
                    :key="stock_material_position.stock_batch_code"
                  >
                    <v-col
                      cols="5"
                      class="caption font-weight-light text--center py-0"
                    >
                      {{
                        $t("Wave.PickingFields.stock_batch_code") +
                        $t("Global.colon")
                      }}{{ stock_material_position.stock_batch_code }}
                    </v-col>
                    <v-col
                      cols="3"
                      class="caption font-weight-light text--center py-0"
                    >
                      {{
                        $t("Wave.PickingFields.stock_batch_num") +
                        $t("Global.colon")
                      }}{{ stock_material_position.stock_unit_num }}
                    </v-col>
                    <v-col
                      cols="4"
                      class="caption font-weight-light text--center py-0"
                    >
                      {{
                        $t("Wave.PickingFields.batch_expiration_date_label") +
                        $t("Global.colon")
                      }}
                      {{
                        $t("Wave.PickingFields.expiration_date", [
                          $datetimeUtils.formatDate(
                            stock_material_position.batch_production_date
                          ),
                          $datetimeUtils.formatDate(
                            stock_material_position.batch_expired_date
                          ),
                        ])
                      }}
                    </v-col>
                  </v-row>
                </td>
              </template>
            </v-data-table>
          </v-container>
          <v-snackbar
            v-model="snackbar"
            color="error"
            timeout="6000"
            text
            top
            absolute
          >
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
              <v-icon
                dark
                class="mx-2"
                v-bind="attrs"
                color="error"
                @click="snackbar = false"
                >fa-times
              </v-icon>
            </template>
          </v-snackbar>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="recommendedPositionsDialog = false"
            >{{ $t("$vuetify.close") }}</v-btn
          >
          <v-btn color="accent" @click="confirm()">{{ $t("CRUD.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import NumberInput from "@/components/plugins/NumberInput";
import Waves from "@/api/waves";

export default {
  name: "RecommendedPositionsDialog",

  props: {
    value: Boolean,
    label: String,
    material: Object,
    positions: Array,
    stock: Object,
  },

  components: {
    NumberInput,
  },

  computed: {
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Wave.PickingFields.stock_position"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("Wave.PickingFields.stock_position_num"),
          align: "start",
          value: "stock_unit_num",
        },
        {
          text: i18n.t("Wave.PickingFields.pick_num"),
          align: "center",
          value: "pick_num",
        },
      ];

      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    recommendedPositionsDialog: false,
    stockPosition: [],
    snackbar: false,
    snackbarMessage: "",
  }),

  methods: {
    confirm() {
      var pickNumCount = 0;
      for (var i = 0; i < this.stockPosition.length; i++) {
        var positionNumTotalCount = 0;
        if (this.stockPosition[i].rate > 1) {
          if (this.stockPosition[i].stock_num) {
            positionNumTotalCount +=
              this.stockPosition[i].stock_num * this.stockPosition[i].rate;
            pickNumCount +=
              this.stockPosition[i].stock_num * this.stockPosition[i].rate;
          }
        }
        if (Number(this.stockPosition[i].default_num)) {
          positionNumTotalCount += Number(this.stockPosition[i].default_num);
          pickNumCount += Number(this.stockPosition[i].default_num);
        }
        if (positionNumTotalCount > this.stockPosition[i].position_num) {
          this.snackbarMessage = i18n.t(
            "Wave.Messages.greater_than_position_num"
          );
          this.snackbar = true;
        }
      }
      if (pickNumCount > this.material.pick_num) {
        this.snackbarMessage = i18n.t("Wave.Messages.greater_than_pick_num");
        this.snackbar = true;
      } else if (pickNumCount < this.material.pick_num) {
        this.snackbarMessage = i18n.t("Wave.Messages.less_than_pick_num");
        this.snackbar = true;
      }
      if (!this.snackbar) {
        this.$emit("positionPickNumEdit", this.stockPosition);
        this.recommendedPositionsDialog = false;
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.recommendedPositionsDialog = this.value;
        if (this.$route.params.id && this.material) {
          //获取库位列表
          Waves.getStockPosition({
            wave_id: this.$route.params.id,
            material_id: this.material.material_id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (Object.keys(response.data.stock_postion).length) {
                  for (var key in response.data.stock_postion) {
                    response.data.stock_postion[key].stock_position_id = key;
                    response.data.stock_postion[key].material_id =
                      this.material.material_id;
                    var position_detail = this.material.positions.find(
                      (position) => position.stock_position_id == key
                    );
                    //库位总拣量
                    response.data.stock_postion[key].default_num =
                      position_detail
                        ? this.$numberFormatter.formatWithDotNoMoreThan(
                            position_detail.positionNumTotal,
                            2
                          )
                        : 0;
                    //已拣量
                    response.data.stock_postion[key].positionNumPicked =
                      position_detail ? position_detail.positionNumPicked : 0;
                    response.data.stock_postion[key].stock_material_position =
                      Object.values(
                        response.data.stock_postion[key].stock_material_position
                      );
                  }
                  let positionArr = Object.values(response.data.stock_postion);
                  positionArr = positionArr.map((position) => {
                    var Description = i18n.t(
                      "MovePositionOrder.DetailFields.position",
                      [position.position_code, position.position_name]
                    );
                    if (this.stock && this.stock.position_name_display) {
                      if (this.stock.position_name_display.indexOf(2) > -1) {
                        Description = position.position_name;
                      }
                      if (
                        this.stock.position_name_display.indexOf(4) > -1 &&
                        Object.keys(position.stock_roadway).length
                      ) {
                        Description =
                          position.stock_roadway.code + " - " + Description;
                      }
                      if (
                        this.stock.position_name_display.indexOf(3) > -1 &&
                        Object.keys(position.stock_area).length
                      ) {
                        Description = position.stock_area.area_name + " - " + Description;
                      }
                    }

                    return Object.assign({}, position, { Description });
                  });
                  this.stockPosition = positionArr;
                }
              }
            }.bind(this)
          );
        }
      },
    },
    recommendedPositionsDialog: {
      handler() {
        this.$emit("input", this.recommendedPositionsDialog);
        if (!this.recommendedPositionsDialog) this.$emit("close");
      },
    },
    snackbar: {
      handler() {
        if (!this.snackbar) this.snackbarMessage = "";
      },
    },
  },
};
</script>